module.exports = __webpack_public_path__ + "staticcomp/img/content_2.f466a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/1/content_2.jpg
// module id = Yg7T
// module chunks = 39